if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant, sectionId } }) => {
    if (!variant) return;
    const root = document.querySelector(`#MainProduct-${sectionId}`);
    if (!root) return;

    const collapse = root.querySelector('[data-description-collapse]');
    const dataScript = root.querySelector('[data-variant-descriptions]');
    if (!collapse || !dataScript) return;

    let map;
    try {
      map = JSON.parse(dataScript.textContent);
    } catch {
      return;
    }

    const html = map[variant.id];
    if (html === undefined) return;

    collapse.innerHTML = html;
  });
}
